services.service('AccountService', [
    'UserService', '$state', 'constants', 'API', 'Utils', 'LoginService', 'ErrorService',
    /**
     * @name AccountService
     * @class
     */
    function (UserService, $state, Const, API, Utils, LoginService, ErrorService) {

        this.switchAccount = function (login, live) {
            var request = {
                login: login,
                live: Utils.fromBoolean(live)
            };

            var user = UserService.get();

            return API.mt4SwitchAccount(request)
                .then(checkResponse)
                .then(function () {
                    user.switchAccount(login, live);
                    user = UserService.get();
                    return LoginService
                        .mt4ClearServices()
                        .then(LoginService.mt4InitServices)
                })
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'AccountService',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        this.createAccount = function (isLive, currency, leverage, tradingPlatform, readOnly = 0) {
            var user = UserService.get();

            var createAccountRequest = {
                live: Utils.fromBoolean(isLive),
                currency: currency || user.currency,
                leverage: leverage || user.leverage
            };

            if (Const['customerTypeForTA']) {
                createAccountRequest.customerType = user.customerType || '';
            }

            if (tradingPlatform) {
                createAccountRequest.tradingPlatform = tradingPlatform;
            }

            if (readOnly) {
                createAccountRequest.readOnly = readOnly
            }

            return API.mt4CreateAccount(createAccountRequest)
                .then(checkResponse)
                .then(function (response) {
                    user.addTradingAccount(response.mt4Account);
                    if (isLive) {
                        user.registrationState = Const.userState.questionnaire;
                    }
                    return response;
                })
        };

        this.checkTradingAccounts = function () {
            var user = UserService.get();

            if (user.emailVerificationRequired) {
                return 'emailVerification';
            }

            if (user.registrationState <= Const.userState.personal) return;

            //skip autocreate account for regulated brand with risk acceptance
            if (user.riskAcceptance) return;

            // trademarkets
            if (user.classification === 'Rejected' && !user.liveAccountExists) return;
            if (!user.classification && user.liveAccountExists) return;

            //check if user has passed the questionnaire but did not make any action in popup risks acceptance
            if (!!Const['scoringRules']) {
                var scoringRule = _.find(Const['scoringRules'], {classification: user.classification});
                if (scoringRule && scoringRule.hasOwnProperty('acceptPopup') && scoringRule['acceptPopup'] === true) {
                    if (user.classification === 'Negative') {
                        console.log('risk acceptance');
                        return 'signupQuestionnaire';
                    }
                }
            }

            //check if user is new (had no deleted live accounts and no any active accounts)
            if (user.tradingAccounts.length === 0 && !user.liveAccountExists) {
                return 'createFirstAccount';
            }

            //check if user has deleted accounts and not active ones
            if (user.tradingAccounts.length === 0 && user.liveAccountExists) {
                return 'accountFrozen';
            }

            //check if no active trading account
            if (!user.activeTradingAccount) {
                return 'root.app.manageAccounts';
            }
        };

        return this;
    }
]);
